import { defineCustomElement } from 'vue'
import { createPinia } from 'pinia'
import { setupAirbrake } from '@dpgradio/creative'
import { Notifier as AirbrakeNotifier } from '@airbrake/browser'
import '@dpgradio/creative/styles/fonts/qmusic.css'
import '@dpgradio/creative/styles/fonts/joe.css'
import '@dpgradio/creative/styles/fonts/willy.css'
import App from './App.ce.vue'

const pinia = createPinia()

const BingoElement = defineCustomElement(App, {
  configureApp: (app) => {
    app.use(pinia)

    if (import.meta.env.PROD) {
      setupAirbrake(
        AirbrakeNotifier,
        {
          projectId: '673456',
          projectKey: '5da2a5d2957b00f7686704d8d5d23ca9',
          version: import.meta.env.VITE_COMMIT_HASH,
        },
        app
      )
    }
  },
})

customElements.define('dario-bingo', BingoElement)
